import * as z from "zod";

export const deleteProductFilter = {
  name: "deleteProductFilter" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ success: z.boolean() }),
};
